import { Box, Tooltip } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { useParams } from "react-router"
import { navigateCompareView } from "../../utilities/project-navigation"
import { useCompareSchedule } from "../../schedule-editor/lib/use-compare-schedule"
import { useAsyncCompareChanges } from "../../schedule-editor/lib/use-async-compare-changes"
import { useEnrichedMacroMapOnce } from "authoring/routes/macro/hooks/use-enriched-macro-map"
import { collectDraftTokenIds } from "../../schedule-editor/lib/schedule-editor-utils"

export function CompareSchedules() {
    const { projectId } = useParams()
    const { targetId: source, schedule } = useBoundContext()
    const isDraft = schedule?.isDraft
    const draft = isDraft ? schedule : null
    const destination = `${projectId}_${source}`
    const { loading: compareLoading, schedule: compareSource } = useCompareSchedule(source)
    const draftTokenIds = collectDraftTokenIds(null, draft, [], [])
    const { macroMap } = useEnrichedMacroMapOnce({
        tokenIds: draftTokenIds,
        retrieveDeleted: false,
    })
    const hasCompareChanges = useAsyncCompareChanges({
        draftId: draft ? `${projectId}:${source}` : undefined,
        draft,
        compareSource,
        compareLoading,
        macroMap,
        enabled: Boolean(draft),
    })
    const disabled = !schedule?.metadata?.published || hasCompareChanges !== true
    const title = !schedule?.metadata?.published || !hasCompareChanges ? "There's nothing to compare." : ""

    return (
        <Tooltip
            title={title}
            slotProps={{
                popper: {
                    sx: {
                        zIndex: 2002,
                    },
                },
            }}
        >
            <Box>
                <ContextMenuItem
                    icon="ic:twotone-compare"
                    label="Compare"
                    onClick={() => navigateCompareView({ destination, source, projectId })}
                    disabled={disabled}
                />
            </Box>
        </Tooltip>
    )
}
